"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var utils_1 = require("../utils/utils");
exports.default = vue_1.defineComponent({
    props: {
        data: {
            type: Object,
            default: function () { return ({}); },
        },
        isH5: {
            type: Boolean,
            default: false,
        },
    },
    setup: function (props, ctx) {
        var data = vue_1.reactive({
            data: {},
        });
        var skeleton = vue_1.ref();
        vue_1.watchEffect(function () {
            data.data = props.data;
            if (!data.data)
                return;
            vue_1.nextTick(function () {
                var _a, _b, _c;
                var containerWidth = ((_a = document.getElementById('messageEle')) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0;
                var max = props.isH5 ? Math.min(containerWidth - 172, 300) : 300;
                var size = utils_1.handleSkeletonSize(240, 240, max, max);
                ((_b = skeleton === null || skeleton === void 0 ? void 0 : skeleton.value) === null || _b === void 0 ? void 0 : _b.style) && (skeleton.value.style.width = size.width + "px");
                ((_c = skeleton === null || skeleton === void 0 ? void 0 : skeleton.value) === null || _c === void 0 ? void 0 : _c.style) && (skeleton.value.style.height = size.height + "px");
            });
        });
        return __assign(__assign({}, vue_1.toRefs(data)), { skeleton: skeleton });
    },
});
